import React from 'react'
//TUTORIAL -> https://www.taniarascia.com/using-context-api-in-react/
const menuLink=[{position:0,to:"",text:"HOME",forFooter:false,visible:true},{position:1,to:"storia-del-laboratorio",text:"STORIA DEL LABORATORIO",forFooter:true,visible:true},
{position:2,to:"shop",text:"SHOP",forFooter:true,visible:false},{position:3,to:"contatti",text:"CONTATTI",forFooter:true,visible:true},]

const startValue = menuLink.filter((res)=>{
  return res.to === window.location.pathname.split('/')[1]
})[0]

export const initialState = {position: startValue ? startValue.position : 99,menuLink};
export const MenuReducer = (state, action) => {
  switch (action.type) {
    case "GOTO":
      return {
        ...state, position:action.payload
      };
    default:
      return state;
  }
};

const MenuContext = React.createContext(initialState);

export const MenuProvider = MenuContext.Provider
export const MenuConsumer = MenuContext.Consumer
export default MenuContext